import { render, staticRenderFns } from "./SelectModalButton.vue?vue&type=template&id=0d8e2caa"
import script from "./SelectModalButton.vue?vue&type=script&lang=js"
export * from "./SelectModalButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports